import { PUBLIC } from 'pricing-pages-ui/constants/AuthType';
import { getPublicPagePath } from 'pricing-pages-ui/utils/urls/publicUtils';
import { start } from './PublicApp';
const publicConfig = {
  authType: PUBLIC,
  rootUrl: getPublicPagePath(),
  defaultHubRoute: '/marketing'
};
start(publicConfig).catch(() => {});